import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the table view for agent list.
 * @extends JetView
 */
export default class tableAgentListView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr('%d-%F-%Y %H:%i:%s'); // Date format for display
        var vthis = this; // Reference to the current instance

        /**
         * Custom checkbox template for action buttons.
         * @param {Object} obj - Data object for the row.
         * @param {Object} common - Common properties.
         * @param {string} value - Value to determine checkbox state.
         * @returns {string} HTML string for the checkbox.
         */
        function custom_checkbox(obj, common, value) {
            if (value != 'I')
                return '';
            else
                return '<div style=" padding: 0px 14px;display: inline-block;background: green;color: #fff;font-size: 13px; " class=\'webix_table_checkbox webixbutton approbarbutton\'>A</div><div style=" padding: 0px 14px;display: inline-block;background: red;color: #fff;font-size: 13px;" class=\'webix_table_checkbox webixbutton rechazarbutton\'> N </div>';
        };

        return {
            rows: [{
                cols: [
                    {
                        view: 'datatable', id: 'datatable', // Data table component
                        css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                        select: true, // Enable row selection
                        columns: [
                            {
                                id: 'Action', header: '', width: 100, height: 25, tooltip: 'Acción', // Action column
                                template: function(obj) {
                                    if (obj.IsRegisterActivate != 'I')
                                        return '';
                                    else
                                        return '<div style=" padding: 0px 14px;display: inline-block;background: green;color: #fff;font-size: 13px; " class=\'webix_table_checkbox webixbutton approbarbutton\'>A</div><div style=" padding: 0px 14px;display: inline-block;background: red;color: #fff;font-size: 13px;" class=\'webix_table_checkbox webixbutton rechazarbutton\'> N </div>';
                                },
                            },
                            {
                                id: 'detailTittle', header: '', width: 50, height: 25, tooltip: _('Detalles'), // Details column
                                template: function(obj) {
                                    return '<span class=\'webix_icon wxi-close details\'></span>'; // Icon for details
                                },
                            },
                            { id: 'Id', header: _('ID Usuario'), width: 100, sort: 'int' }, // User ID column
                            {
                                id: 'LoyaltyLevel', // Unique identifier for this column, usually matching the data field key.
                                header: _('Nivel de Lealtad'), // The column header text shown in the table, translated using the _() function.
                                width: 100, // Sets the column width to 100 pixels.
                                sort: 'int', // Enables sorting on this column as integers (numeric sort).
                            },
                            {
                                id: 'Login',
                                header: _('Usuario (Correo electrónico)'),
                                width: 250,
                                sort: 'int',
                                hidden: !devConfig.getPermAction('sensitiveInformationEmail', 'Add'), // Conditional visibility based on permissions
                            },
                            {
                                id: 'RiskStatus', header: _('Nivel de Riesgo'), tooltip: function(obj) {
                                    if (obj.RiskStatus === 'NC') {
                                        return 'Usuario sin categorización de score de riesgo';
                                    }
                                    return 'Nivel de Riesgo';
                                }, // Risk status column
                                template: function(obj) {
                                    if (obj.RiskStatus == 'B')
                                        return '<div style=" padding: 0px 14px;display: inline-block;background: green;color: #fff;font-size: 13px; width: 25px;  " class=\'webixbutton\'>Bajo</div>';
                                    if (obj.RiskStatus == 'M')
                                        return '<div style=" padding: 0px 14px;display: inline-block;background: yellow;color: #000000;font-size: 13px; width: 35px;  " class=\'webixbutton\'>Medio</div>';
                                    if (obj.RiskStatus == 'A')
                                        return '<div style=" padding: 0px 14px;display: inline-block;background: red;color: #fff;font-size: 13px; width: 25px;  " class=\'webixbutton\'>Alto</div>';
                                    if (obj.RiskStatus == 'NC')
                                        return '<div style=" padding: 0px 14px;display: inline-block;background: grey;color: #fff;font-size: 13px; width: auto;  " class=\'webixbutton\'>No Clasificado</div>';
                                    else
                                        return '';
                                }, width: 150,
                                perm: 'RiskStatus', // Permission for risk status
                            },
                            {
                                id: 'FirstName',
                                header: _('Nombre'),
                                width: 100,
                                sort: 'int',
                                hidden: !devConfig.getPermAction('sensitiveInformationNames', 'Add'), // Conditional visibility based on permissions
                            },
                            {
                                id: 'LastName',
                                header: _('Apellido'),
                                width: 200,
                                sort: 'int',
                                hidden: !devConfig.getPermAction('sensitiveInformationSurnames', 'Add'), // Conditional visibility based on permissions
                            },
                            {
                                id: 'DocNumber',
                                header: _('Documento'),
                                width: 150,
                                sort: 'int',
                                hidden: !devConfig.getPermAction('sensitiveInformationIdentificationDocument', 'Add'), // Conditional visibility based on permissions
                            },
                            { id: 'DNI', header: _('DNI'), width: 100, sort: 'int' }, // DNI column
                            { id: 'Ip', header: 'Ip', width: 200, sort: 'int' }, // IP column
                            {
                                id: 'MobilePhone',
                                header: _('Teléfono'),
                                width: 200,
                                sort: 'int',
                                hidden: !devConfig.getPermAction('sensitiveInformationCellPhoneNumber', 'Add'), // Conditional visibility based on permissions
                            },
                            {
                                id: 'IsRegisterActivate', header: _('Estado de Registro'), editor: 'combo', options: [
                                    { 'id': 'A', 'value': _('Activo') },
                                    { 'id': 'I', 'value': _('Inactivo') },
                                    { 'id': 'R', 'value': _('Rechazado') }], width: 150, sort: 'int', // Registration status column with options
                            },
                            {
                                id: 'IsActivate', header: _('Estado'), options: [
                                    { 'id': 'A', 'value': _('Activo') },
                                    { 'id': 'I', 'value': _('Inactivo') },
                                    { 'id': 'B', 'value': _('Bloqueado') }], width: 150, sort: 'int', // Activation status column with options
                            },
                            {
                                id: 'CreatedLocalDate', header: _('Fecha de Creación'),
                                fillspace: 0, minWidth: 0, width: 200,
                                sort: 'text', format: dateFormat, // Creation date column with formatting
                            },
                            {
                                id: 'LastLoginLocalDate', header: _('Fecha de ultimo login'),
                                fillspace: 0, minWidth: 0, width: 200,
                                sort: 'text', format: dateFormat, // Last login date column with formatting
                            },
                            {
                                id: 'IsPep', header: _('PEP'), options: [
                                    { 'id': 'S', 'value': _('Si') },
                                    { 'id': 'N', 'value': _('No') }], width: 150, sort: 'int', // PEP status column with options
                            },
                            {
                                id: 'IsEnhancedRegimen', header: _('Régimen Reforzado'), options: [
                                    { 'id': 'S', 'value': _('Si') },
                                    { 'id': 'N', 'value': _('No') }], width: 150, sort: 'int', // IsEnhancedRegimen status column with options
                            },
                            {
                                id: 'AcceptanceDate', header: _('Fecha de Aceptacion PEP'),
                                fillspace: 0, minWidth: 0, width: 250,
                                sort: 'text', format: dateFormat, // Acceptance date column with formatting
                            },
                            { id: 'CodePromotional', header: _('Codigo Promocional'), width: 100, sort: 'int' }, // Promotional code column
                            { id: 'IdCodePromotional', header: _('Id Codigo Promocional'), width: 100, sort: 'text' }, // Promotional code ID column
                            { id: 'Site', header: _('Sitio'), width: 100, sort: 'text' }, // Site column
                            {
                                id: 'IsPhoneVerification', header: _('Celular verificado'), options: [
                                    { 'id': 'A', 'value': _('Verificado') },
                                    { 'id': 'I', 'value': _('No verificado') }], width: 150, sort: 'int', // Phone verification status column with options
                            },
                        ],
                        onClick: {
                            'details': function(euv, id) { // Click event for details icon
                                if (vthis.getUrl()[0].page !== 'customers')
                                    vthis.show('customers?user=' + id + '/information'); // Show customer information
                                else vthis.show('information');
                            },
                            approbarbutton: function(ev, id) { // Click event for approve button
                                var item = this.getItem(id); // Get the clicked item
                                if (item.IsRegisterActivate == 'I') {
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea activar registro?'),
                                        ok: _('Activar registro'),
                                        cancel: _('Salir'),
                                        callback: function(action) {
                                            if (action === true) {
                                                const data = // Data to send for activation
                                                    {
                                                        'Id': item.Id,
                                                        'Action': 'A',
                                                    };
                                                webix.ajax().headers({
                                                    'Content-type': 'application/json',
                                                }).post(devConfig.geturlApi() + 'Client/ActivateClient', data, {
                                                    error: function(text, data, XmlHttpRequest) {
                                                        webix.message(('Error')); // Error message on failure
                                                    },
                                                    success: function(text, data, XmlHttpRequest) {
                                                        var json = JSON.parse(text); // Parse response
                                                        if (json.HasError) {
                                                            webix.message({
                                                                title: '¡Mensaje!',
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error, comuniquese con soporte'), // Error message on server error
                                                            });
                                                        } else {
                                                            item.IsRegisterActivate = 'A'; // Update item status
                                                            item.Action = 'A'; // Update action
                                                            webix.message(('Saved')); // Success message
                                                            $$('datatable').refresh(); // Refresh the datatable
                                                        }
                                                    },
                                                });
                                            }
                                        },
                                    });
                                } else {
                                    webix.message({
                                        title: '¡Mensaje!',
                                        type: 'alert-error',
                                        text: _('No puedes activar un registro ya actualizado.'), // Error message if already updated
                                    });
                                }
                            },
                            rechazarbutton: function(ev, id) { // Click event for reject button
                                var item = this.getItem(id); // Get the clicked item
                                if (item.IsRegisterActivate == 'I') {
                                    webix.confirm({
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea rechazar registro?'),
                                        ok: _('Rechazar registro'),
                                        cancel: _('Salir'),
                                        callback: function(action) {
                                            if (action === true) {
                                                const data = // Data to send for rejection
                                                    {
                                                        'Id': item.Id,
                                                        'Action': 'R',
                                                    };
                                                webix.ajax().headers({
                                                    'Content-type': 'application/json',
                                                }).post(devConfig.geturlApi() + 'Client/RejectClient', data, {
                                                    error: function(text, data, XmlHttpRequest) {
                                                        webix.message(('Error')); // Error message on failure
                                                    },
                                                    success: function(text, data, XmlHttpRequest) {
                                                        var json = JSON.parse(text); // Parse response
                                                        if (json.HasError) {
                                                            webix.message({
                                                                title: _('¡Mensaje!'),
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error, comuniquese con soporte'), // Error message on server error
                                                            });
                                                        } else {
                                                            item.IsRegisterActivate = 'R'; // Update item status
                                                            item.Action = 'R'; // Update action
                                                            $$('datatable').refresh(); // Refresh the datatable
                                                            webix.message(('Saved')); // Success message
                                                        }
                                                    },
                                                });
                                            }
                                        },
                                    });
                                } else {
                                    webix.message({
                                        title: '¡Mensaje!',
                                        type: 'alert-error',
                                        text: _('No puedes activar un registro ya actualizado.'), // Error message if already updated
                                    });
                                }
                            },
                        },
                        tooltip: true, // Enable tooltips
                        math: true, // Enable math calculations
                        loadahead: 0, // Load ahead configuration
                        datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                        autoConfig: false, // Disable auto configuration
                        pager: 'pagerA', // Pager ID for pagination
                        on: {
                            onItemDblClick: id => { // Double click event for item
                                if (this.getUrl()[0].page !== 'customers')
                                    this.show('customers?user=' + id + '/information'); // Show customer information
                                else this.show('information');
                            },
                            onBeforeLoad: function() { // Before load event
                                this.showOverlay('<div id=\'contenedor\'; class=\'container-preload\'><div style=\'position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;\' class=\'progress\'><div class=\'icon-preload girando\'></div><div class=\'load-text\'>Loading... </div></div></div>'); // Show loading overlay
                            },
                            onAfterLoad: function() { // After load event
                                this.hideOverlay(); // Hide loading overlay
                            },
                        },
                        ready: function() { // Ready event for the datatable
                            if (!this.count()) {
                                webix.extend(this, webix.OverlayBox); // Extend with overlay box
                                this.showOverlay('<div class=\'no-data\' style=\'margin:75px; font-size:18px;\'>' + _('No hay datos') + '</div>'); // Show no data overlay
                            }
                        },
                    },
                ],
            },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        var url = devConfig.geturlApi() + 'es/Client/GetClients', // API endpoint for fetching clients
            grid = $$('datatable'); // Reference to the datatable
        var vthis = this; // Reference to the current instance
        var filter = ''; // Filter string for API requests

        // Event listener for filtering data
        this.on(this.app, 'playersList:filter', filterData => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if ((typeof object[i][1] !== 'object') && (object[i][1] !== '')) {
                    if (object[i][0] == 'Datepicker') {
                        if (object[i][1] !== ' ') {
                            var date = object[i][1].split(' - '); // Split date range
                            string1 = string1 + '&dateFrom=' + date[0]; // Add start date to filter
                            string1 = string1 + '&dateTo=' + date[1]; // Add end date to filter
                        }
                    } else {
                        if (object[i][0] == 'AcceptanceDate') {
                            if (object[i][1] !== ' ') {
                                var date = object[i][1].split(' - '); // Split acceptance date range
                                string1 = string1 + '&AcceptanceDateFrom=' + date[0]; // Add start acceptance date to filter
                                string1 = string1 + '&AcceptanceDateTo=' + date[1]; // Add end acceptance date to filter
                            }
                        } else if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Format date
                                string1 = string1 + '&dateFrom=' + date; // Add date to filter
                                string1 = string1 + '&dateTo=' + date; // Add date to filter
                            }
                        }
                    }
                } else {
                    if ((typeof object[i][1] === 'object')) {
                        var object2 = Object.entries(object[i][1]); // Convert nested filter data to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom = 'dateFrom=' + ((d.getFullYear())) + ':' + ('00' + (d.getMonth() + 1)).slice(-2) + ':' + ('00' + d.getDate()).slice(-2) + ' ' + ('00' + d.getHours()).slice(-2) + ':' + ('00' + d.getMinutes()).slice(-2) + ':' + ('00' + d.getSeconds()).slice(-2); // Format start date
                                    string1 = string1 + '&' + dateFrom; // Add start date to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo = 'dateTo=' + ((d.getFullYear())) + ':' + ('00' + (d.getMonth() + 1)).slice(-2) + ':' + ('00' + d.getDate()).slice(-2) + ' ' + ('00' + d.getHours()).slice(-2) + ':' + ('00' + d.getMinutes()).slice(-2) + ':' + ('00' + d.getSeconds()).slice(-2); // Format end date
                                        string1 = string1 + '&' + dateTo; // Add end date to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            $$('consultButton').define('disabled', true); // Disable consult button
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1).then((response) => {
                $$('consultButton').define('disabled', false); // Enable consult button after loading
            }).catch((e) => {
                $$('consultButton').define('disabled', false); // Enable consult button on error
            });
            filter = string1; // Update filter string
        });

        // Event listener for pagination
        $$('pagerA').attachEvent('onAfterPageChange', function(page) {
            webix.delay(function() {
                if (page != '0') {
                    chargeTable(); // Load data for the new page
                }
            }, '', '', 100);
        });

        // Event listener for window resize
        this.on(this.app, 'changeSize', filterData => {
            chargeTable(); // Reload table data on size change
        });

        /**
         * Loads data into the grid based on pagination and filters.
         */
        function chargeTable() {
            var size = grid.getPager().config.size; // Get current page size
            var page = grid.getPage(); // Get current page number
            var first = size * page; // Calculate first item index
            var last = (first + size) - 1; // Calculate last item index
            grid.load(url + '?start=' + (first) + '&count=' + (last + 1) + filter); // Load data with pagination and filters
        }

        // Event listener for sorting
        grid.attachEvent('onAfterSort', function(by, dir, as) {
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir); // Load sorted data
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function(id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for edit start
        grid.attachEvent('onBeforeEditStart', function(id) {
            var item = this.getItem(id); // Get item being edited
            console.log(item); // Log item details
            if (id.column == 'Action') {
                var options = this.getColumnConfig('Action').collection; // Get action column options
                if (item.IsRegisterActivate != 'I') {
                    console.log(item); // Log item details
                    return false; // Prevent editing if not inactive
                }
                console.log(id); // Log column ID
            }
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', Id => {
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id); // Load data for selected player
        });

        /**
         * Converts a file to Base64 format.
         * @param {File} file - The file to convert.
         * @returns {Promise} Promise that resolves with the Base64 string.
         */
        function getBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader(); // File reader instance
                reader.readAsDataURL(file); // Read file as data URL
                reader.onload = () => resolve(reader.result); // Resolve promise with result
                reader.onerror = error => reject(error); // Reject promise on error
            });
        }

        var base64CSV = ''; // Variable to hold Base64 CSV data
        var base64CSV33 = ''; // Variable to hold Base64 CSV data for another use
        var popupAdd = webix.ui({ // Popup for massive contingency
            view: 'window',
            id: 'MassiveContingency',
            fullscreen: (screen.width < 500) ? true : false, // Fullscreen for small screens
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Activar Contingencia Masiva') }, // Popup title
                    {
                        view: 'icon', icon: 'wxi-close', click: function() {
                            this.getTopParentView().hide(); // Close popup
                        },
                    },
                ],
            },
            position: 'center', // Center position
            modal: true, // Modal popup
            body: {
                view: 'form', id: 'addContingencyForm', // Form for adding contingency
                elements: [
                    {
                        margin: 10,
                        rows: [
                            {
                                view: 'uploader', id: 'uploader', value: _('Cargar archivo CSV'), // File uploader
                                on: {
                                    onBeforeFileAdd: function(upload) {
                                        getBase64(upload.file).then(
                                            data => base64CSV = data, // Convert file to Base64
                                        );
                                        $$('uploader').define('label', upload.name); // Update uploader label
                                        $$('uploader').refresh(); // Refresh uploader
                                    },
                                },
                            },
                            {
                                view: 'multiselect',
                                label: _('Tipo'),
                                labelPosition: 'top',
                                required: true,
                                name: 'Contingencies',
                                options: [
                                    { 'id': '0', 'value': _('Contingencia Total') },
                                    { 'id': '1', 'value': _('Contingencia Deportivas') },
                                    { 'id': '2', 'value': _('Contingencia Casino') },
                                    { 'id': '3', 'value': _('Contingencia Casino en Vivo') },
                                    { 'id': '4', 'value': _('Contingencia Virtuales') },
                                    { 'id': '5', 'value': _('Contingencia Poker') },
                                    { 'id': '6', 'value': _('Contingencia Retiro') },
                                    { 'id': '7', 'value': _('Contingencia Depósito') },
                                    { 'id': '8', 'value': _('Abusador de bonos') },
                                    { 'id': '9', 'value': _('Contingencia Retail') },
                                    { 'id': '10', 'value': _('Contingencia Depósitos Retail') },
                                    { 'id': '11', 'value': _('Contingencia Depósitos Pasarelas') },
                                ], // Options for contingency types
                            },
                            {
                                view: 'textarea',
                                labelPosition: 'top',
                                label: _('Descripción:'),
                                name: 'Description',
                                labelWidth: 150,
                                required: true,
                                height: 150, // Textarea for description
                            },
                        ],
                    },
                    {
                        cols: [
                            {
                                view: 'button', value: _('Cancelar'), click: function() {
                                    this.getTopParentView().hide(); // Close popup
                                    $$('addContingencyForm').setValues($$('addContingencyForm').getCleanValues()); // Reset form values
                                    $$('uploader').define('label', _('Cargar archivo CSV')); // Reset uploader label
                                    $$('uploader').refresh(); // Refresh uploader
                                    base64CSV = ''; // Clear Base64 data
                                },
                            },
                            {
                                view: 'button', type: 'form', value: _('Guardar'), click: function($e) {
                                    var values = $$('addContingencyForm').getValues(); // Get form values
                                    if ($$('addContingencyForm').validate() && base64CSV != '') {
                                        webix.ajax().headers({
                                            'Content-type': 'application/json',
                                        }).post(devConfig.geturlApi() + 'Client/MassiveContingency', '{"CSV":"' + base64CSV + '","Type":"0","Description":"' + values.Description + '","Contingencies":"' + values.Contingencies + '"}', {
                                            error: function(text, data, XmlHttpRequest) {
                                                $$('addContingencyForm').setValues($$('addContingencyForm').getCleanValues()); // Reset form values
                                                webix.message('Error! '); // Error message on failure
                                            },
                                            success: function(text, data, XmlHttpRequest) {
                                                text = JSON.parse(text); // Parse response
                                                if (text.HasError) {
                                                    $$('addContingencyForm').setValues($$('addContingencyForm').getCleanValues()); // Reset form values
                                                    webix.message('Error: ' + text.AlertMessage); // Error message on server error
                                                } else {
                                                    $$('addContingencyForm').setValues($$('addContingencyForm').getCleanValues()); // Reset form values
                                                    webix.message('Contingencia masiva creada'); // Success message
                                                }
                                            },
                                        });
                                        this.getTopParentView().hide(); // Close popup
                                    } else {
                                        webix.message({
                                            title: _('¡Mensaje!'),
                                            type: 'alert-error',
                                            text: _('Completa los campos...'), // Error message for incomplete fields
                                        });
                                    }
                                },
                            },
                        ],
                    },
                ], elementsConfig: {
                    on: {
                        onChange: function() {
                            this.validate(); // Validate form on change
                        },
                    },
                },
            },
        });

        // Event listener for massive contingency button
        this.on(this.app, 'massiveContingency:button', filter => {
            popupAdd.show(); // Show popup
        });

        let popupAdd33 = webix.ui({ // Popup for deactivating massive contingency
            view: 'window',
            id: 'DesactiveMassiveContingency',
            fullscreen: (screen.width < 500) ? true : false, // Fullscreen for small screens
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Desactivar Contingencia Masiva') }, // Popup title
                    {
                        view: 'icon', icon: 'wxi-close', click: function() {
                            this.getTopParentView().hide(); // Close popup
                        },
                    },
                ],
            },
            position: 'center', // Center position
            modal: true, // Modal popup
            body: {
                view: 'form', id: 'addDesactiveContingencyForm', // Form for deactivating contingency
                elements: [
                    {
                        margin: 10,
                        rows: [
                            {
                                view: 'uploader', id: 'uploader22', value: _('Cargar archivo CSV'), // File uploader
                                on: {
                                    onBeforeFileAdd: function(upload) {
                                        getBase64(upload.file).then(
                                            data => base64CSV33 = data, // Convert file to Base64
                                        );
                                        $$('uploader22').define('label', upload.name); // Update uploader label
                                        $$('uploader22').refresh(); // Refresh uploader
                                    },
                                },
                            },
                            {
                                view: 'combo',
                                label: _('Tipo'),
                                labelPosition: 'top',
                                required: true,
                                name: 'Contingency',
                                options: [
                                    { 'id': '0', 'value': _('Contingencia Total') },
                                    { 'id': '1', 'value': _('Contingencia Deportivas') },
                                    { 'id': '2', 'value': _('Contingencia Casino') },
                                    { 'id': '3', 'value': _('Contingencia Casino en Vivo') },
                                    { 'id': '4', 'value': _('Contingencia Virtuales') },
                                    { 'id': '5', 'value': _('Contingencia Poker') },
                                    { 'id': '6', 'value': _('Contingencia Retiro') },
                                    { 'id': '7', 'value': _('Contingencia Depósito') },
                                    { 'id': '8', 'value': _('Abusador de bonos') },
                                    { 'id': '9', 'value': _('Contingencia Retail') },
                                    { 'id': '10', 'value': _('Contingencia Depósitos Retail') },
                                    { 'id': '11', 'value': _('Contingencia Depósitos Pasarelas') },
                                ], // Options for contingency types
                            },
                            {
                                view: 'textarea',
                                labelPosition: 'top',
                                label: _('Descripción:'),
                                name: 'Description',
                                labelWidth: 150,
                                required: true,
                                height: 150, // Textarea for description
                            },
                        ],
                    },
                    {
                        cols: [
                            {
                                view: 'button', value: _('Cancelar'), click: function() {
                                    this.getTopParentView().hide(); // Close popup
                                    $$('addDesactiveContingencyForm').setValues($$('addDesactiveContingencyForm').getCleanValues()); // Reset form values
                                    $$('uploader22').define('label', _('Cargar archivo CSV')); // Reset uploader label
                                    $$('uploader22').refresh(); // Refresh uploader
                                    base64CSV33 = ''; // Clear Base64 data
                                },
                            },
                            {
                                view: 'button', type: 'form', value: _('Guardar'), click: function($e) {
                                    var values = $$('addDesactiveContingencyForm').getValues(); // Get form values
                                    if ($$('addDesactiveContingencyForm').validate() && base64CSV33 != '') {
                                        webix.ajax().headers({
                                            'Content-type': 'application/json',
                                        }).post(devConfig.geturlApi() + 'Client/DesactiveMassiveContingency', '{"CSV":"' + base64CSV33 + '","Type":"0","Description":"' + values.Description + '","Contingencies":"' + values.Contingency + '"}', {
                                            error: function(text, data, XmlHttpRequest) {
                                                $$('addDesactiveContingencyForm').setValues($$('addDesactiveContingencyForm').getCleanValues()); // Reset form values
                                                webix.message('Error! '); // Error message on failure
                                            },
                                            success: function(text, data, XmlHttpRequest) {
                                                text = JSON.parse(text); // Parse response
                                                if (text.HasError) {
                                                    $$('addDesactiveContingencyForm').setValues($$('addDesactiveContingencyForm').getCleanValues()); // Reset form values
                                                    webix.message('Error: ' + text.AlertMessage); // Error message on server error
                                                } else {
                                                    $$('addDesactiveContingencyForm').setValues($$('addDesactiveContingencyForm').getCleanValues()); // Reset form values
                                                    webix.message('Contingencia masiva creada'); // Success message
                                                }
                                            },
                                        });
                                        this.getTopParentView().hide(); // Close popup
                                    } else {
                                        webix.message({
                                            title: _('¡Mensaje!'),
                                            type: 'alert-error',
                                            text: _('Completa los campos...'), // Error message for incomplete fields
                                        });
                                    }
                                },
                            },
                        ],
                    },
                ], elementsConfig: {
                    on: {
                        onChange: function() {
                            this.validate(); // Validate form on change
                        },
                    },
                },
            },
        });

        // Event listener for deactivating massive contingency button
        this.on(this.app, 'desactiveMassiveContingency:button', filter => {
            popupAdd33.show(); // Show popup
        });

        var base64CSV2 = ''; // Variable to hold Base64 CSV data for categorization
        var popupAdd2 = webix.ui({ // Popup for massive categorization
            view: 'window',
            id: 'MassiveCategorization',
            fullscreen: (screen.width < 500) ? true : false, // Fullscreen for small screens
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Categorización masiva') }, // Popup title
                    {
                        view: 'icon', icon: 'wxi-close', click: function() {
                            this.getTopParentView().hide(); // Close popup
                        },
                    },
                ],
            },
            position: 'center', // Center position
            modal: true, // Modal popup
            body: {
                view: 'form', id: 'addContingencyForm2', // Form for adding categorization
                elements: [
                    {
                        margin: 10,
                        rows: [
                            {
                                view: 'uploader', id: 'uploader2', value: _('Cargar archivo CSV'), // File uploader
                                on: {
                                    onBeforeFileAdd: function(upload) {
                                        getBase64(upload.file).then(
                                            data => base64CSV2 = data, // Convert file to Base64
                                        );
                                        $$('uploader2').define('label', upload.name); // Update uploader label
                                        $$('uploader2').refresh(); // Refresh uploader
                                    },
                                },
                            },
                            {
                                view: 'combo',
                                labelPosition: 'top',
                                label: _('Tipo'),
                                required: true,
                                name: 'Categorization',
                                options: [
                                    { 'id': '0', 'value': _('0') },
                                    { 'id': '1', 'value': _('1') },
                                    { 'id': '2', 'value': _('2') },
                                    { 'id': '3', 'value': _('3') },
                                    { 'id': '4', 'value': _('4') },
                                    { 'id': '5', 'value': _('5') },
                                ], // Options for categorization types
                            },
                        ],
                    },
                    {
                        cols: [
                            {
                                view: 'button', value: _('Cancelar'), click: function() {
                                    this.getTopParentView().hide(); // Close popup
                                    $$('addContingencyForm2').setValues($$('addContingencyForm2').getCleanValues()); // Reset form values
                                    $$('uploader2').define('label', _('Cargar archivo CSV')); // Reset uploader label
                                    $$('uploader2').refresh(); // Refresh uploader
                                    base64CSV2 = ''; // Clear Base64 data
                                },
                            },
                            {
                                view: 'button', type: 'form', value: _('Guardar'), click: function($e) {
                                    var values = $$('addContingencyForm2').getValues(); // Get form values
                                    if ($$('addContingencyForm2').validate() && base64CSV2 != '') {
                                        webix.ajax().headers({
                                            'Content-type': 'application/json',
                                        }).post(devConfig.geturlApi() + 'Client/MassiveCategorization', '{"CSV":"' + base64CSV2 + '","Categorization":"' + values.Categorization + '"}', {
                                            error: function(text, data, XmlHttpRequest) {
                                                webix.message('Error! '); // Error message on failure
                                            },
                                            success: function(text, data, XmlHttpRequest) {
                                                text = JSON.parse(text); // Parse response
                                                if (text.HasError) {
                                                    webix.message('Error: ' + text.AlertMessage); // Error message on server error
                                                } else {
                                                    webix.message('Contingencia masiva creada'); // Success message
                                                }
                                            },
                                        });
                                        this.getTopParentView().hide(); // Close popup
                                    } else {
                                        webix.message({
                                            title: _('¡Mensaje!'),
                                            type: 'alert-error',
                                            text: _('Completa los campos...'), // Error message for incomplete fields
                                        });
                                    }
                                },
                            },
                        ],
                    },
                ], elementsConfig: {
                    on: {
                        onChange: function() {
                            this.validate(); // Validate form on change
                        },
                    },
                },
            },
        });

        // Event listener for categorization contingency button
        this.on(this.app, 'categorizationContingency:button', filter => {
            popupAdd2.show(); // Show popup
        });
    }
}

// FILE DOCUMENTED
